<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-btn
          color="secondary"
          class="ma-2"
          @click="bulkDevicesDialog = true"
        >
          הוספת רשימת מכשירים
        </v-btn>
        <v-btn
          color="secondary"
          class="ma-2"
        >
          יצירת משתמשי גרמין
        </v-btn>
      </v-col>
    </v-row>
    <bulk-devices-dialog />
  </v-container>
</template>

<script>
import BulkDevicesDialog from "@/components/BulkDevicesDialog";

export default {
  data() {
    return {
      tab: null
    };
  },

  computed: {
    resources() {
      return this.$store.state.resources;
    },
    firebaseUsers() {
      return this.$store.state.entities.firebaseUsers;
    },
    loading() {
      return Object.keys(this.firebaseUsers).length;
    },
    bulkDevicesDialog: {
      get() {
        return this.$store.state.bulkDevicesDialog;
      },
      set(isActive) {
        this.$store.commit("TOGGLE_BULK_DEVICES_DIALOG", isActive);
      }
    }
  },

  mounted() {
    this.$store.dispatch("API_GET", {
      url: "/users/firebase",
      entityType: "firebaseUsers",
      schema: "firebaseUserListSchema"
    });
  },

  components: {
    BulkDevicesDialog
  }
};
</script>

<style scoped>
</style>
